// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ERAA2PjtJ7eyCE {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 96px;
  padding: 8px;
  overflow: hidden;
  border-radius: 8px;
  background-color: var(--ds-skeleton, #091e420f);
  background-position: center center;
  background-size: cover;
  color: var(--ds-text-subtle, #44546f);
  font-size: 16px;
  line-height: 20px;
  text-align: start;
}
.ERAA2PjtJ7eyCE:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.XUx9onFuYTmMXu {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
}
.VcgvBszsl3Dr0N {
  display: inline-block;
  flex: 0 0 auto;
  width: 100%;
  max-height: 40px;
  overflow: hidden;
  font-weight: bold;
  word-wrap: break-word;
}
.j8aHIWV8JJPMNF {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.WCoVrDjrZE4CvD {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  line-height: 16px;
}
.V7TTWDhDuFslWb {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.sxOppP7rMSqoOZ {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 108px;
  overflow: hidden;
  border-radius: 8px;
  background-color: var(--ds-skeleton, #091e420f);
  background-position: center center;
  background-size: cover;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.sxOppP7rMSqoOZ:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.tcjgckM9rKZW8a {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: column;
  height: 100%;
}
.oOpOQZKEfAHqHw {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: 72px;
}
.nXaBuUin8C0H4s {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: 8px;
  overflow: hidden;
  border-radius: 6px;
  background-color: var(--ds-background-inverse-subtle, #00000029);
  --ds-icon: #ffffff;
}
.rSNLES3xz4QAXm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: 8px;
}
.bxCjbISBOZb4R6 {
  flex: 1;
  background-color: var(--ds-surface, #ffffff);
  text-align: start;
}
.iBQYAY10d_Lp1J {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 8px;
  overflow: hidden;
  color: var(--ds-text, #172b4d);
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTile": `ERAA2PjtJ7eyCE`,
	"boardDetails": `XUx9onFuYTmMXu`,
	"boardName": `VcgvBszsl3Dr0N`,
	"badges": `j8aHIWV8JJPMNF`,
	"visiblityContainer": `WCoVrDjrZE4CvD`,
	"helpContainer": `V7TTWDhDuFslWb`,
	"newBoardTile": `sxOppP7rMSqoOZ`,
	"tileDetails": `tcjgckM9rKZW8a`,
	"iconContainer": `oOpOQZKEfAHqHw`,
	"lockIconContainer": `nXaBuUin8C0H4s`,
	"helpIconContainer": `rSNLES3xz4QAXm`,
	"tileNameContainer": `bxCjbISBOZb4R6`,
	"tileName": `iBQYAY10d_Lp1J`
};
export default ___CSS_LOADER_EXPORT___;
